export const scrollToElement = (elm) => {
  if (!elm) {
    return
  }
  elm.scrollIntoView({ behavior: 'smooth' })
}
